/**
 * Utilidad para enviar eventos a Google Tag Manager de forma segura
 * Espera a que GTM esté completamente cargado antes de enviar eventos
 */

let gtmReady = false;
let pendingEvents = [];

// Verificar si GTM ya está cargado
const checkGTMReady = () => {
  if (typeof window === 'undefined') return false;

  window.dataLayer = window.dataLayer || [];

  // Buscar el evento gtm.load que indica que GTM está listo
  const hasGtmLoad = window.dataLayer.some(item => item.event === 'gtm.load');

  if (hasGtmLoad) {
    gtmReady = true;
    // Enviar eventos pendientes
    pendingEvents.forEach(event => {
      window.dataLayer.push(event);
    });
    pendingEvents = [];
  }

  return hasGtmLoad;
};

// Esperar a que GTM esté listo con reintentos
const waitForGTM = (callback, maxAttempts = 20, attempt = 0) => {
  if (checkGTMReady()) {
    callback();
    return;
  }

  if (attempt < maxAttempts) {
    setTimeout(() => {
      waitForGTM(callback, maxAttempts, attempt + 1);
    }, 250); // Revisar cada 250ms, máximo 5 segundos
  } else {
    // Si después de 5 segundos GTM no está listo, enviar de todos modos
    callback();
  }
};

/**
 * Envía un evento a GTM de forma segura
 * @param {string} eventName - Nombre del evento
 * @param {object} eventData - Datos adicionales del evento (opcional)
 */
export const pushGTMEvent = (eventName, eventData = {}) => {
  const event = {
    event: eventName,
    ...eventData
  };

  if (gtmReady) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  } else {
    waitForGTM(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);
    });
  }
};

// Inicializar verificación de GTM al cargar el módulo
if (typeof window !== 'undefined') {
  // Verificar inmediatamente
  checkGTMReady();

  // Si no está listo, configurar un listener
  if (!gtmReady) {
    const originalPush = window.dataLayer.push.bind(window.dataLayer);
    window.dataLayer.push = function(...args) {
      const result = originalPush(...args);
      // Verificar si el evento que se acaba de pushear es gtm.load
      args.forEach(item => {
        if (item && item.event === 'gtm.load') {
          gtmReady = true;
          // Enviar eventos pendientes
          pendingEvents.forEach(event => {
            originalPush(event);
          });
          pendingEvents = [];
        }
      });
      return result;
    };
  }
}

export default pushGTMEvent;
